<template>
  <g>
    <g clip-path="url(#clip0_15_474)">
      <path
        d="M15.5 15.3803V8.62026L18.88 12.0003L15.5 15.3803ZM20.29 12.7103C20.68 12.3203 20.68 11.6903 20.29 11.3003L15.7 6.71026C15.08 6.08026 14 6.52026 14 7.41026V16.5803C14 17.4703 15.08 17.9203 15.71 17.2903L20.29 12.7103ZM10 16.5903V7.41026C10 6.52026 8.92 6.07026 8.29 6.70026L3.7 11.2903C3.31 11.6803 3.31 12.3103 3.7 12.7003L8.29 17.2903C8.92 17.9203 10 17.4803 10 16.5903Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_474">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
